import { ICollection } from "services/types";
import { IAddGifParamsToCollection, IEditCollectionParams } from "services/CollectionService";
import { IAppAction } from "../appAction";

export const collectionsActions = {
  FETCH_MY_COLLECTIONS: "FETCH_MY_COLLECTIONS",
  FETCH_COLLECTIONS_SUCCESS: "FETCH_COLLECTIONS_SUCCESS",
  FETCH_COLLECTIONS_ERROR: "FETCH_COLLECTIONS_ERROR",
  SET_COLLECTIONS_EMPTY: "SET_COLLECTIONS_EMPTY",

  SET_TOTAL_COLLECTIONS: "SET_TOTAL_COLLECTIONS",

  FETCH_MY_CURRENT_COLLECTION: "FETCH_MY_CURRENT_COLLECTION",
  FETCH_CURRENT_COLLECTION_SUCCESS: "FETCH_CURRENT_COLLECTION_SUCCESS",
  FETCH_CURRENT_COLLECTION_ERROR: "FETCH_CURRENT_COLLECTION_ERROR",

  SET_COLLECTIONS_OWNER_NAME: "SET_COLLECTIONS_OWNER_NAME",

  CREATE_COLLECTION: "CREATE_COLLECTION",
  CREATE_COLLECTION_SUCCESS: "CREATE_COLLECTION_SUCCESS",
  CREATE_COLLECTION_ERROR: "CREATE_COLLECTION_ERROR",

  EDIT_COLLECTION: "EDIT_COLLECTION",
  EDIT_COLLECTION_SUCCESS: "EDIT_COLLECTION_SUCCESS",
  EDIT_COLLECTION_ERROR: "EDIT_COLLECTION_ERROR",

  ADD_GIF_TO_COLLECTION: "ADD_GIF_TO_COLLECTION",
  ADD_GIF_TO_COLLECTION_SUCCESS: "ADD_GIF_TO_COLLECTION_SUCCESS",
  ADD_GIF_TO_COLLECTION_ERROR: "ADD_GIF_TO_COLLECTION_ERROR",

  SET_NEW_COLLECTION_ID: "SET_NEW_COLLECTION_ID"
};

export const fetchMyCollections = (payload: any): IAppAction => ({
  type: collectionsActions.FETCH_MY_COLLECTIONS,
  payload: payload
});

export const fetchCollectionsSuccess = (payload: any): IAppAction => ({
  type: collectionsActions.FETCH_COLLECTIONS_SUCCESS,
  payload
});

export const fetchCollectionError = (error: Error): IAppAction => ({
  type: collectionsActions.FETCH_COLLECTIONS_ERROR,
  payload: error
});

export const setTotalCollections = (total: number): IAppAction => ({
  type: collectionsActions.FETCH_COLLECTIONS_ERROR,
  payload: total
});

export const setEmptyCollections = (): IAppAction => ({
  type: collectionsActions.SET_COLLECTIONS_EMPTY
});

export const fetchMyCurrentCollection = (payload: any): IAppAction => ({
  type: collectionsActions.FETCH_MY_CURRENT_COLLECTION,
  payload: payload
});

export const fetchCurrentCollectionSuccess = (payload: ICollection): IAppAction => ({
  type: collectionsActions.FETCH_CURRENT_COLLECTION_SUCCESS,
  payload: payload
});

export const fetchCurrentCollectionError = (payload: Error): IAppAction => ({
  type: collectionsActions.FETCH_CURRENT_COLLECTION_ERROR,
  payload: payload
});

export const setCollectionsOwnerName = (collectionsOwnerName: string): IAppAction => ({
  type: collectionsActions.SET_COLLECTIONS_OWNER_NAME,
  payload: collectionsOwnerName
});

export const createCollection = (payload: IEditCollectionParams): IAppAction => ({
  type: collectionsActions.CREATE_COLLECTION, payload
});

export const createCollectionSuccess = (payload: any): IAppAction => ({
  type: collectionsActions.CREATE_COLLECTION_SUCCESS, payload
});

export const createCollectionError = (payload: Error): IAppAction => ({
  type: collectionsActions.CREATE_COLLECTION_ERROR, payload
});

export const editCollection = (payload: IEditCollectionParams): IAppAction => ({
  type: collectionsActions.EDIT_COLLECTION, payload
});

export const editCollectionSuccess = (payload: any): IAppAction => ({
  type: collectionsActions.EDIT_COLLECTION_SUCCESS, payload
});

export const editCollectionError = (payload: Error): IAppAction => ({
  type: collectionsActions.EDIT_COLLECTION_ERROR, payload
});

export const addGifToCollection = (payload: IAddGifParamsToCollection): IAppAction => ({
  type: collectionsActions.ADD_GIF_TO_COLLECTION,
  payload
});

export const addGifToCollectionSuccess = (payload: any): IAppAction => ({
  type: collectionsActions.ADD_GIF_TO_COLLECTION_SUCCESS,
  payload
});

export const addGifToCollectionError = (payload: Error): IAppAction => ({
  type: collectionsActions.ADD_GIF_TO_COLLECTION_ERROR,
  payload
});

export const setNewCollectionId = (payload: string | null) => ({
  type: collectionsActions.SET_NEW_COLLECTION_ID,
  payload
});
